import {  CommonModule  } from '@angular/common';
import {  Component     ,
          Input         } from '@angular/core';
import {  TranslatePipe } from 'nv@services/translate.service';
import { CcMap } from "../../../../@shared/components/cc-map/cc-map.component";

@Component({
    selector    : 'template-competition',
    templateUrl: './template-competition.component.html',
    imports: [CommonModule, TranslatePipe, CcMap]
})
export class TemplateCompetition {

    @Input() public inputData: any;
    @Input() public inputIsVisible = false

    public getCompetitionMarkers() {
        return this.inputData.competition?.latLongOfAllChargers
    }

    getColorForLevel(level: string): string {
        return level.includes("Level 1") ? '#6D9953'
             : level.includes("Level 2") ? '#d91c5c'
             : 'blue'
    }
}